import { useConnection } from "@solana/wallet-adapter-react";
import { useEffect, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import type { UserDomainData } from "../../utils/name-service";
import { getUserDomains } from "../../utils/name-service";

export const useUserDomains = () => {
  const [userDomains, setUserDomains] = useState<UserDomainData[]>([]);
  const [refreshing, setRefreshing] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const { connected, publicKey, watching } = useEnrichedWallet();
  const { connection } = useConnection();

  useEffect(() => {
    if (connected && publicKey) {
      setRefreshing(true);
      getUserDomains(connection, publicKey)
        .then((data) => {
          setUserDomains(data);
          setRefreshing(false);
        })
        .catch((err) => {
          console.log("Error fetching user domains", err);
        });
    }
  }, [connected, connection, publicKey, forceRefresh]);

  useEffect(() => {
    setUserDomains([]);
  }, [connected, publicKey, watching]);

  return {
    userDomains,
    isUserDomainsRefreshing: refreshing,
    refreshUserDomains: () => setForceRefresh(!forceRefresh),
  };
};
